export const selectLabels = {
  all: 'All',
  notEmptyIas: 'Not Empty IAs',
  productIas: 'Product IAs',
  infoIas: 'Info IAs',
  emptyIas: 'Empty IAs'
};

export const jumpToLabels = {
  nextShotStart: 'Next Shot Start',
  prevShotStart: 'Previous Shot Start'
};

export const copyLabels = {
  iasToShotsInGroup: 'Copy selected IAs to shots in group',
  copy: 'Copy',
  paste: 'Paste'
};

export const cat04Labels = {
  detachEntity: 'Detach Person/Product',
  deleteIaFromShot: 'from this shot',
  deleteIaFromAllShots: 'from all shots'
};

export const cat05labels = {
  setLocation: 'Set shot as Location end'
};

export const zIndexLabels = {
  moveToTop: 'Move to Top',
  moveToBottom: 'Move to Bottom',
  moveUp: 'Move Up',
  moveDown: 'Move Down'
}

export const defaultContextMenu = {
  // position: { top: layerY, left: layerX },
  options: {
    category03: [
      {
        label: 'Create New Cut',
        action: () => alert('clicked NEW CUT'),
        checkable: false,
        checked: false,
        shortcut: '',
        subOptions: []
      },
      // {
      //   label: 'Combine Current Shot With',
      //   action: null,
      //   checkable: false,
      //   checked: false,
      //   shortcut: '',
      //   subOptions: [
      //     {
      //       label: 'Next Shot',
      //       action: () => alert('clicked NEXT SHOT'),
      //       checkable: false,
      //       checked: false,
      //       shortcut: 'ctrl+shift+[',
      //       subOptions: []
      //     },
      //     {
      //       label: 'Previous Shot',
      //       action: () => alert('clicked PREVIOUS SHOT'),
      //       checkable: false,
      //       checked: false,
      //       shortcut: 'ctrl+shift+]',
      //       subOptions: []
      //     }
      //   ]
      // },
      {
        label: 'Jump to',
        action: null,
        checkable: false,
        checked: false,
        shortcut: '',
        subOptions: [
          {
            label: jumpToLabels.nextShotStart,
            action: () => alert('clicked NEXT SHOT START'),
            checkable: false,
            checked: false,
            shortcut: 'alt+right',
            subOptions: []
          },
          {
            label: jumpToLabels.prevShotStart,
            action: () => alert('clicked PREVIOUS SHOT START'),
            checkable: false,
            checked: false,
            shortcut: 'alt+left',
            subOptions: []
          }
        ]
      }
    ]
  }
};

export const defaultCategory01 = [
  {
    label: 'Anchor',
    action: () => alert('clicked ANCHOR'),
    checkable: true,
    checked: false,
    shortcut: '',
    subOptions: []
  }
];

export const defaultCategory02 = [
  {
    label: 'Select',
    action: null,
    checkable: false,
    checked: false,
    shortcut: '',
    subOptions: [
      {
        label: selectLabels.all,
        action: () => alert('clicked ALL'),
        checkable: false,
        checked: false,
        shortcut: '',
        subOptions: []
      },
      {
        label: selectLabels.notEmptyIas,
        action: () => alert('clicked NOT EMPTY IAs'),
        checkable: false,
        checked: false,
        shortcut: '',
        subOptions: []
      },
      {
        label: selectLabels.productIas,
        action: () => alert('clicked PRODUCT IAs'),
        checkable: false,
        checked: false,
        shortcut: '',
        subOptions: []
      },
      {
        label: selectLabels.infoIas,
        action: () => alert('clicked INFO IAs'),
        checkable: false,
        checked: false,
        shortcut: '',
        subOptions: []
      },
      {
        label: selectLabels.emptyIas,
        action: () => alert('clicked EMPTY IAs'),
        checkable: false,
        checked: false,
        shortcut: '',
        subOptions: []
      }
    ]
  }
];

export const defaultCategory04 = [
  {
    label: copyLabels.iasToShotsInGroup,
    action: () => alert('clicked Copy selected IAs to shots in group'),
    checkable: false,
    checked: false,
    shortcut: 'ctrl+j',
    subOptions: []
  },
  {
    label: copyLabels.copy,
    action: () => alert('clicked COPY'),
    checkable: false,
    checked: false,
    shortcut: 'ctrl+c',
    subOptions: []
  },
  {
    label: 'Delete Interactive Area',
    action: () => alert('clicked DELETE IA'),
    checkable: false,
    checked: false,
    shortcut: 'del',
    subOptions: []
  }
];

export const defaultCategory05 = [
  {
    label: cat05labels.setLocation,
    action: () => alert('clicked Set Location'),
    checkable: false,
    checked: false,
    shortcut: 'ctrl+l',
    subOptions: []
  }
];

export const defaultCategory06 = [
  {
    label: 'Arrange',
    action: null,
    checkable: false,
    checked: false,
    shortcut: '',
    subOptions: [
      {
        label: zIndexLabels.moveToTop,
        action: () => alert('clicked Move to Top'),
        checkable: false,
        checked: false,
        shortcut: '',
        subOptions: []
      },
      {
        label: zIndexLabels.moveToBottom,
        action: () => alert('clicked Move to Bottom'),
        checkable: false,
        checked: false,
        shortcut: '',
        subOptions: []
      },
      {
        label: zIndexLabels.moveUp,
        action: () => alert('clicked Move Up'),
        checkable: false,
        checked: false,
        shortcut: '',
        subOptions: []
      },
      {
        label: zIndexLabels.moveDown,
        action: () => alert('clicked Move Down'),
        checkable: false,
        checked: false,
        shortcut: '',
        subOptions: []
      }
    ]
  }
];

export const defaultMarkAsOptions = {
  label: 'Mark as',
  action: null,
  checkable: false,
  checked: false,
  shortcut: '',
  subOptions: [
    {
      label: 'In',
      action: () => alert('clicked IN'),
      checkable: false,
      checked: false,
      shortcut: 'ctrl+i',
      subOptions: []
    },
    {
      label: 'Out',
      action: () => alert('clicked OUT'),
      checkable: false,
      checked: false,
      shortcut: 'ctrl+o',
      subOptions: []
    }
  ]
};